import { useMemo } from "react";
import { GenerateTreinamentosListaColumns } from "./columns";
import { Link, Breadcrumbs, Typography, Stack, TablePagination } from "@mui/material";
import { Header } from "./components/header";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { CadastroTreinamentoModal } from "./components/cadastro_treinamento_modal";
import { useTreinamentosListaViewModel } from "../../viewModels/treinamentos_lista_view_model";
import { CopyTreinamentoModal } from "./components/copy_treinamento_modal";
import { Treinamento } from "../../../domain/models/treinamento";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";

/**
 * TreinamentosLista
 */

export const TreinamentosLista = () => {
  const viewModel = useTreinamentosListaViewModel();

  const columnsDef = useMemo(() => {
    return GenerateTreinamentosListaColumns({
      onActionEdit: viewModel.handleTreinamentoCadastroOpenState,
      onActionDelete: viewModel.handleTreinamentoDeleteOpenState,
      onActionCopy: viewModel.handleTreinamentoCopyOpenState,
    });
  }, [
    viewModel.handleTreinamentoCadastroOpenState,
    viewModel.handleTreinamentoDeleteOpenState,
    viewModel.handleTreinamentoCopyOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[12rem]">
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={viewModel.handleInativarSelecionados}>
                  Inativar Selecionados
                </PrimaryButton>
              </div>

              <div className="w-[200px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleTreinamentoCadastroOpenState(null, true)}>
                  Novo Treinamento
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Treinamentos
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Treinamento</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2">

          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  tipoPesquisa={viewModel.filters.tipoPesquisa}
                  valueField={viewModel.filters.valueField}
                  status={viewModel.filters.status}
                  onTipoPesquisaChange={viewModel.handleTipoPesquisaChange}
                  onValueFieldChange={viewModel.handleValueFieldChange}
                  onStatusChange={viewModel.handleStatusChange} />

                <div className="text-red-500">
                  Para cadastrar uma nova versão de treinamento, basca clicar no botão copiar, escrever a nova versão e salvar. Em seguida inative o treinamento com a versão anterior. Não se esqueça de vincular o novo treinamento aos cargos.
                </div>

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col flex-wrap justify-end">
                      <LegendComponent>
                        <LegendItemComponent
                          icon={<LegendIcon color='green' title='A' />}
                          label='Ativo' />

                        <LegendItemComponent
                          icon={<LegendIcon color='red' title='I' />}
                          label='Inativo' />

                      </LegendComponent>
                    </div>

                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="treinamentos_lista"
                    disableRowSelectionOnClick={true}
                    disableColumnMenu={false}
                    checkboxSelection={true}
                    getRowId={(row: Treinamento) => row.idTreinamento}
                    columns={columnsDef}
                    loading={viewModel.loading}
                    rowSelectionModel={viewModel.selectionModel}
                    onRowSelectionModelChange={viewModel.handleTreinamentoRowSelectionChange}
                    rows={viewModel.treinamentos}
                    rowCount={viewModel.treinamentos.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }} />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }

        <CadastroTreinamentoModal
          open={viewModel.openCadastroModal}
          saving={viewModel.saving}
          selectedTreinamento={viewModel.selectedTreinamento ?? null}
          onSubmit={viewModel.handleSubmitTreinamento}
          onOpenChangeHistory={viewModel.handleOpenChangeHistory}
          onClose={() => viewModel.handleTreinamentoCadastroOpenState(null, false)} />

        <CopyTreinamentoModal
          open={viewModel.openCopyModal}
          saving={viewModel.saving}
          selectedTreinamento={viewModel.selectedTreinamento ?? null}
          onSubmit={viewModel.handleTreinamentoCopyConfirm}
          onClose={viewModel.handleTreinamentoCopyOpenState} />

        <DeleteDialog
          open={viewModel.openDeleteModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleTreinamentoDeleteOpenState(null, false)}
          title={`Você realmente deseja excluir este item?`}
          onDelete={viewModel.handleConfirmarDeletarTreinamento} />

        {/**
          * Modal historico de alterações.
          */}

        <ChangeHistoryModal
          changeHistoryHandler={viewModel.changeHistory} />

      </div>
    </>
  );
}